import { metaConversionsApi } from "src/services/api";
import { getTopLevelDomain } from "./domain.util";

/**
 * Get Facebook cookies (fbc and fbp) from browser cookies
 */
const getFacebookCookies = (): { fbc?: string; fbp?: string } => {
  if (typeof document === "undefined") return {};

  const cookies = document.cookie.split(";");
  let fbc: string | undefined;
  let fbp: string | undefined;

  cookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split("=");
    if (name === "_fbc") {
      fbc = decodeURIComponent(value);
    } else if (name === "_fbp") {
      fbp = decodeURIComponent(value);
    }
  });

  return { fbc, fbp };
};

/**
 * Get country code from domain
 */
const getCountryFromDomain = (): string => {
  const domain = getTopLevelDomain();

  const domainToCountry: Record<string, string> = {
    hr: "HR", // Croatia
    sk: "SK", // Slovakia
    at: "AT", // Austria
    cz: "CZ", // Czech Republic
    pl: "PL", // Poland
    si: "SI", // Slovenia
    it: "IT", // Italy
  };

  return domainToCountry[domain] || "SI"; // Default to Slovenia
};

/**
 * Track page view with Meta Conversions API
 */
export const trackMetaPageView = async (url: string, pageTitle?: string) => {
  try {
    const { fbc, fbp } = getFacebookCookies();
    const country = getCountryFromDomain();
    const userAgent = navigator.userAgent;

    await metaConversionsApi.metaConversionsControllerTrackPageView(
      userAgent,
      {
        pageUrl: url,
        pageTitle: pageTitle || document.title,
        fbc,
        fbp,
        country,
      }
    );

    console.log("Meta page view tracked:", { url, pageTitle, country });
  } catch (error) {
    console.error("Error tracking Meta page view:", error);
    // Don't throw - tracking should never break the app
  }
};
